var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-hj-suppress":""}},[_vm._l((_vm.lines),function(line,index){return [(index !== 0)?_c('br',{key:index}):_vm._e(),_vm._v(" "+_vm._s(line)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }